import React, { createContext, useContext, useState, ReactNode } from "react";
import CustomSnackbar from "../common/CustomSnackbar";
import AppConstants from "constants/AppConstants";

interface ErrorContextProps {
  showError: (message: string) => void;
}

const ErrorContext = createContext<ErrorContextProps | undefined>(undefined);

export const useError = (): ErrorContextProps => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within an ErrorProvider");
  }
  return context;
};

export const ErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);

  const showError = (message: string) => {
    setErrorMessage(message);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    setErrorMessage(""); // Clear the error message
  };

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}
      <CustomSnackbar
        open={snackbarOpen}
        message={errorMessage}
        type="error"
        handleClose={handleCloseSnackbar}
        autoHideDuration={AppConstants.SNACKBAR.AUTO_HIDE_TIMEOUT}
      />
    </ErrorContext.Provider>
  );
};